import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/admin/')({
  component: () => <Navigate replace search to="/bo/admin" />,
})
